import React from 'react';
import { MagnifyingGlass, Puff,Circles, Bars } from 'react-loader-spinner'
import { Styles } from "../../components/styles/nomination";


const Modal = ({ loadModal }) => {
    return (

        <Styles>
            <div className='modal-loader-position'>
                {/* <MagnifyingGlass
                    visible={loadModal}
                    height="80"
                    width="80"
                    ariaLabel="MagnifyingGlass-loading"
                    wrapperStyle={{}}
                    wrapperClass="MagnifyingGlass-wrapper"
                    glassColor='#c0efff'
                    color='#063970'
                /> */}
                {/* <Puff
                    height="80"
                    width="80"
                    radius={5}
                    color="#063970"
                    ariaLabel="puff-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={loadModal}
                /> */}
                <Bars
                    height="80"
                    width="80"
                    color="#063970"
                    ariaLabel="circles-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={loadModal}
                />
            </div>
        </Styles>


    )
}

export default Modal
